import { gql } from '@apollo/client';

export const QUERY_LABS = gql`
  query labs {
    labs {
      id
      name
    }
  }
`;

export const QUERY_REFERRING_PROVIDERS = gql`
  query referringProviders {
    referringProviders {
      id
      name
      marketId
    }
  }
`;

export const QUERY_PREDICTED_ADDRESSES = gql`
  query AddressPrediction($input: String!) {
    addressPrediction(input: $input) {
      description
    }
  }
`;
export const QUERY_ADDRESS_DETAILS = gql`
  query FindZips($input: String!, $city: String, $stateId: String) {
    findZips(input: $input, city: $city, stateId: $stateId) {
      zip
      timezone
      city
      stateId
    }
  }
`;

export const FETCH_SOLERA_MEMBER_DETAILS = gql`
  mutation FetchSoleraMemberDetails($enrollmentIdentifier: String!) {
    fetchSoleraMemberDetails(enrollmentIdentifier: $enrollmentIdentifier) {
      soleraMemberDetails {
        email
        givenName
        familyName
        phoneNumber
        address {
          address1
          address2
          city
          state
          zipCode
        }
        birthdate
      }
    }
  }
`;
